$(function () {
    $(document).on('click', '.mc-modal-control', function (e) {
        e.preventDefault();
        create($(this));
    });
});

/**
 * Create modal
 *
 * @param activator
 * @param contentHandler
 */
export function create(activator, contentHandler = () => void 0) {
    setContent(
        activator,
        createContainer(activator.attr('modal-size')),
        contentHandler
    );
}

/**
 * Create modal container
 *
 * @param size
 * @returns {*|jQuery|HTMLElement}
 */
function createContainer(size) {
    let load = Fnc.htmlLoader(),
        modalContainer = $('#myModal');

    modalContainer.remove();

    let html = '<div class="modal fade bd-example-modal-lg" id="myModal">'
        + '<div class="modal-dialog modal-' + size + '">'
        + '<div class="modal-content">'
        + '<div class="loader-container">' + load + '</div>'
        + '</div></div></div>';

    $('body').append(html);

    modalContainer = $('#myModal');
    new Bootstrap.Modal(modalContainer, {
        backdrop: true, // 'static' will close modal only using 'cross'
        keyboard: false
    }).show();

    return modalContainer;
}

/**
 * Set modal content
 *
 * @param activator
 * @param container
 * @param contentHandler
 */
function setContent(activator, container, contentHandler = () => void 0) {
    let overlay = container.find('.overlay'),
        url = activator.attr('href'),
        method = activator.data('method');

    $.ajax({
        url: url,
        type: method,
        beforeSend: function () {
            overlay.show();
        },
        success: function (response) {
            if (response[FNC_ERROR_MESSAGE_PARAM]) {
                Fnc.notify('error', LANG_NOTIFY['error'], response[FNC_ERROR_MESSAGE_PARAM]);
                setTimeout(function () {
                    container.modal('hide');
                }, 500);
            } else {
                let modalContainer = $('#myModal .modal-content');

                modalContainer.html(response);
                Init.initJs(modalContainer);
                Init.initVCustomValidation();
                contentHandler(modalContainer, response);
            }

            overlay.hide();
        },
        error: function (error) {
            setTimeout(function () {
                Fnc.notify(
                    'error',
                    LANG_NOTIFY['error'],
                    error.responseJSON.message !== undefined ? error.responseJSON.message : SOMETHING_WENT_WRONG
                );
                container.modal('hide');
            }, 1000);
        }
    });
}
